import React, { useState } from "react";
import API from "../utils/axiosInstance";
import "./EditProfile.css";

const EditProfile = ({ user = {}, onClose, onUpdate }) => {
  const [formData, setFormData] = useState({
    name: user?.name || "",
    email: user?.email || "",
    phone: user?.phone || "",
  });

  const [profileImage, setProfileImage] = useState(null);
  const [preview, setPreview] = useState(user?.profileImage || "/images/profile.svg");
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileImage(file);
      setPreview(URL.createObjectURL(file));
      console.log("📁 Image selected:", file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const data = new FormData();
      data.append("name", formData.name);
      data.append("email", formData.email);
      data.append("phone", formData.phone);

      if (profileImage) {
        data.append("profileImage", profileImage); // MUST match multer key
        console.log("🧾 Appending image:", profileImage.name);
      }

      console.log("📤 Submitting profile update...");
      const res = await API.put("/users/profile", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("✅ Profile updated:", res.data);
      onUpdate(res.data);
      onClose();
    } catch (err) {
      console.error("❌ Profile update failed:", err);
      if (err.response) console.error("Server said:", err.response.data);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="edit-profile-overlay">
      <div className="edit-profile-container">
        <button className="close-btn" onClick={onClose}>×</button>
        <h2>Edit Profile</h2>

        <div className="profile-image-wrapper">
          <label htmlFor="profile-upload">
            <img
              className="profile-image-clickable"
              src={preview}
              alt="Profile"
            />
          </label>
          <input
            id="profile-upload"
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={handleImageChange}
          />
        </div>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>Name :</label>
            <input
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter your name"
            />
          </div>

          <div className="input-group">
            <label>Email :</label>
            <input
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
            />
          </div>

          <div className="input-group">
            <label>Phone :</label>
            <input
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Enter your phone number"
            />
          </div>

          <button className="update-btn" type="submit" disabled={saving}>
            {saving ? "Saving..." : "Update Profile"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditProfile;
